module.exports = __webpack_public_path__ + "img/softball_protective.758dd219.svg";